
export default function HelpUsersItemsService(gettext) {

    'ngInject';

    this.getModule = function () {
        var module = {
            "id": "profile",
            "name": gettext("Profile"),
            "description": gettext("This is the information of the logged in user. It’s accessed by clicking the name of the logged in user on the top right of the page."),
            "icon": "fas fa-question-circle",
            "priority": 9,
            "items": [{
                "orderid": 9.1,
                "itemid": "usersprofilepersonal",
                "helpitemid": "profile",
                "name": gettext("Personal Information"),
                "templateUrl": "users/users.profile.html"
            },
            {
                "orderid": 9.2,
                "itemid": "usersprofilechangepassword",
                "helpitemid": "profile",
                "name": gettext("Password"),
                "templateUrl": "users/users.profile.changepassword.html"
            },
            {
                "orderid": 9.3,
                "itemid": "usersprofilechangeemail",
                "helpitemid": "profile",
                "name": gettext("Change Email Address"),
                "templateUrl": "users/users.profile.changeemail.html"
            },
            {
                "orderid": 9.4,
                "itemid": "userssubscriptions",
                "helpitemid": "profile",
                "name": gettext("System Notifications"),
                "templateUrl": "users/users.notifications.html"
            }
            ]
        };
        return module;
    };
}
